export default __webpack_public_path__ + "static/media/expoindo-9.9a0124f6.jpg";